export function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

/**
 * immutably merge two objects
 * using a custom function over lodash to keep default bundle sizes low
 * citation: https://stackoverflow.com/a/37164538/1790362
 * @param target object to base merge from (immutably)
 * @param source object to merge
 * @returns new object
 */
export function mergeDeep(target: any, source: any) {
  let output = Object.assign({}, target)
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] })
        } else {
          output[key] = mergeDeep(target[key], source[key])
        }
      } else {
        Object.assign(output, { [key]: source[key] })
      }
    })
  }
  return output
}
